// import { AspectRatio, Box, Flex, Heading, Image, Text } from '@chakra-ui/react';
// import { useEffect } from 'react';
// import Rectangle4157 from '../../assets/Rectangle4157.png';
// import Rectangle4158 from '../../assets/Rectangle4158.png';
// import Rectangle4159 from '../../assets/Rectangle4159.png';
// import Rectangle4160 from '../../assets/Rectangle4160.png';
// import Rectangle4161 from '../../assets/Rectangle4161.png';
// import Ellipse167 from '../../assets/Ellipse167.png';
// import Ellipse168 from '../../assets/Ellipse168.png';
// import Ellipse169 from '../../assets/Ellipse169.png';
// import Ellipse170 from '../../assets/Ellipse170.png';
// import Ellipse171 from '../../assets/Ellipse171.png';
// import Slider from 'react-slick';
// import { useDispatch, useSelector } from 'react-redux';
// import { get_brands, selectBrandAction } from 'redux/actions/productActions';
// import { useNavigate } from 'react-router-dom';
// import { toInitials } from 'utils/utils';

// const Brands = () => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const { brands } = useSelector((state) => state.productReducer);
//     const slicedBrands = brands?.slice(0, 4);

//     const settings = {
//         dots: true,
//         infinite: true,
//         speed: 500,
//         slidesToShow: 4,
//         slidesToScroll: 1,
//     };

//     useEffect(() => {
//         let ignore = true;

//         if (ignore) {
//             dispatch(get_brands());
//         }
//         return () => false;
//     }, [dispatch]);

//     return (
//         <Box mt="10">
//             <Flex alignItems="center" justifyContent="space-between">
//                 <Heading fontSize="22px" fontWeight="800" mb="20px" mt="20px">
//                     Brands
//                 </Heading>
//                 <Box
//                     as="span"
//                     textDecor="underline"
//                     color="gray.400"
//                     cursor="pointer"
//                     fontSize="19px"
//                     fontWeight="medium"
//                     onClick={() => navigate('/dashboard/brands')}>
//                     See all
//                 </Box>
//             </Flex>
//             <Slider {...settings}>
//                 {slicedBrands &&
//                     slicedBrands.map((brand) => (
//                         <Box
//                             key={brand?.brand_id}
//                             width="full"
//                             border="1px solid"
//                             borderColor="gray.300"
//                             borderRadius="md"
//                             p="4"
//                             cursor="pointer"
//                             _hover={{ transform: 'translateY(-7px)' }}
//                             onClick={() => {
//                                 navigate(`/dashboard/brands/${brand.brand_id}`);
//                                 dispatch(selectBrandAction(brand));
//                             }}>
//                             <Box
//                                 height={{ base: '7.2813rem', lg: '11.375rem' }}
//                                 borderRadius={'0.3544rem'}
//                                 backgroundColor={brand.image ? '' : 'rgba(27, 59, 95, 0.1)'}
//                                 padding={brand.image ? '' : '4'}>
//                                 {brand?.image ? (
//                                     <Image
//                                         src={brand?.image}
//                                         height="full"
//                                         width="full"
//                                         objectFit="contain"
//                                     />
//                                 ) : (
//                                     <Flex
//                                         w="full"
//                                         h="full"
//                                         alignItems={'center'}
//                                         justifyContent={'center'}>
//                                         <AspectRatio w="full" h="auto" ratio={{ base: 1 }}>
//                                             <Flex
//                                                 fontSize={{ base: '2xl', lg: '4xl' }}
//                                                 fontWeight={'semibold'}
//                                                 aspectRatio={'1/1'}
//                                                 borderRadius={'100%'}
//                                                 borderWidth={1}
//                                                 w="max-content"
//                                                 maxW={'full'}
//                                                 alignItems={'center'}
//                                                 justifyContent={'center'}
//                                                 px={2}
//                                                 py={1}
//                                                 style={{
//                                                     aspectRatio: '1 / 1',
//                                                 }}
//                                                 borderColor={'#1b3b5f'}
//                                                 textColor={'#1b3b5f'}>
//                                                 {toInitials(brand.name)}
//                                             </Flex>
//                                         </AspectRatio>
//                                     </Flex>
//                                 )}
//                             </Box>
//                             <Text textAlign="center" fontWeight="500" mt={3} isTruncated>
//                                 {brand.name}
//                             </Text>
//                         </Box>
//                     ))}
//             </Slider>
//         </Box>
//     );
// };

// export default Brands;

// export const sampleBrands = [
//     {
//         id: 1,
//         main: Rectangle4157,
//         sub: Ellipse167,
//     },
//     {
//         id: 2,
//         main: Rectangle4158,
//         sub: Ellipse168,
//     },
//     {
//         id: 3,
//         main: Rectangle4159,
//         sub: Ellipse169,
//     },
//     {
//         id: 4,
//         main: Rectangle4160,
//         sub: Ellipse170,
//     },
//     {
//         id: 5,
//         main: Rectangle4161,
//         sub: Ellipse171,
//     },
// ];

import { memo, useCallback } from 'react';
import {
    Box, Flex, Heading, Text, Image, Skeleton, SkeletonCircle, Button,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

/* ─────────────────────────────────────────────────────────────
   Brands.js — dashboard inline "Shop by Brand" carousel
   Mirrors ShopByVendor visual treatment:
     - Card wrapper with SectionTitle + "See all" link
     - Horizontal scrolling strip of circular brand avatars
     - Same dimensions (52px avatar, 80px slot width)
     - Skeleton loading state
     - Empty state
   ───────────────────────────────────────────────────────────── */

const NAVY        = '#1B3B5F';
const CYAN        = '#DCF8F9';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';

const SHADOW_SM = '0 1px 3px rgba(27,59,95,0.06)';
const FONT      = "'Bricolage Grotesque', sans-serif";

const BRAND_CAROUSEL_COUNT = 12;   /* How many to load into the carousel */

/* ─────────────────────────────────────────────────────────────
   ICONS
   ───────────────────────────────────────────────────────────── */
const TagIcon = (props) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.42L11.59 21.42C11.95 21.79 12.44 22 13 22C13.56 22 14.05 21.79 14.41 21.41L21.41 14.41C21.79 14.05 22 13.56 22 13C22 12.44 21.78 11.95 21.41 11.58ZM6.5 7.5C5.67 7.5 5 6.83 5 6C5 5.17 5.67 4.5 6.5 4.5C7.33 4.5 8 5.17 8 6C8 6.83 7.33 7.5 6.5 7.5Z" />
    </svg>
);
const ChevronRightIcon = (props) => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const toInitial = (name) => (name?.[0] ?? '?').toUpperCase();

/* ─────────────────────────────────────────────────────────────
   SECTION TITLE
   ───────────────────────────────────────────────────────────── */
const SectionTitle = memo(function SectionTitle({ onSeeAll }) {
    return (
        <Flex align="center" justify="space-between" mb="10px" gap="10px">
            <Flex align="center" gap="8px" minW="0" flex="1">
                <Flex
                    align="center"
                    justify="center"
                    bg={NAVY}
                    color="white"
                    borderRadius="7px"
                    w="24px"
                    h="24px"
                    flexShrink={0}
                >
                    <TagIcon />
                </Flex>
                <Box minW="0" flex="1">
                    <Heading
                        fontSize="14px"
                        fontWeight="800"
                        color={INK}
                        lineHeight="1.2"
                        fontFamily={FONT}
                        letterSpacing="-0.01em"
                    >
                        Shop by Brand
                    </Heading>
                    <Text fontSize="10.5px" color={FAINT} mt="1px" fontWeight="500">
                        Browse products from popular brands
                    </Text>
                </Box>
            </Flex>
            {onSeeAll && (
                <Button
                    variant="ghost"
                    size="xs"
                    color={NAVY}
                    fontWeight="600"
                    fontSize="10.5px"
                    px="6px"
                    h="24px"
                    rightIcon={<ChevronRightIcon />}
                    _hover={{ bg: CYAN }}
                    borderRadius="6px"
                    onClick={onSeeAll}
                    flexShrink={0}
                >
                    See all
                </Button>
            )}
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   BRAND AVATAR
   ───────────────────────────────────────────────────────────── */
const BrandAvatar = memo(function BrandAvatar({ brand, size = '52px', fontSize = '18px' }) {
    const initial = toInitial(brand?.name);
    return (
        <Flex
            w={size}
            h={size}
            borderRadius="full"
            bg={brand?.image ? SURFACE : CYAN}
            color={NAVY}
            align="center"
            justify="center"
            fontWeight="800"
            fontSize={fontSize}
            fontFamily={FONT}
            overflow="hidden"
            border="1px solid"
            borderColor={BORDER}
            flexShrink={0}
        >
            {brand?.image ? (
                <Image
                    src={brand.image}
                    alt={brand.name}
                    w="full"
                    h="full"
                    objectFit="cover"
                    fallback={
                        <Flex w="full" h="full" align="center" justify="center" bg={CYAN}>
                            {initial}
                        </Flex>
                    }
                />
            ) : (
                initial
            )}
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   CAROUSEL SKELETON SLOT — single shimmer placeholder
   ───────────────────────────────────────────────────────────── */
const BrandSkeleton = memo(function BrandSkeleton() {
    return (
        <Flex
            direction="column"
            align="center"
            gap="6px"
            flexShrink={0}
            minW="80px"
            p="6px"
        >
            <SkeletonCircle size="52px" startColor={SURFACE_ALT} endColor={BORDER} />
            <Skeleton h="2.5" w="60%" borderRadius="3px" startColor={SURFACE_ALT} endColor={BORDER} />
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   MAIN
   ───────────────────────────────────────────────────────────── */
const Brands = () => {
    const navigate = useNavigate();

    const brands = useSelector((s) => s.productReducer?.brands);
    const isLoading =
        brands == null ||
        (Array.isArray(brands) && brands.length === 0 && !window.__obanaBrandsFetched);

    const items = Array.isArray(brands)
        ? brands.filter((b) => b && b.name).slice(0, BRAND_CAROUSEL_COUNT)
        : [];

    const goToBrand = useCallback(
        (brand) => {
            if (!brand?.brand_id) return;
            navigate(`/dashboard/brands/${brand.brand_id}`);
        },
        [navigate]
    );

    return (
        <Box
            bg={SURFACE}
            borderRadius="14px"
            p={{ base: '14px', md: '16px' }}
            border="1px solid"
            borderColor={BORDER}
            boxShadow={SHADOW_SM}
            mb="14px"
        >
            <SectionTitle onSeeAll={() => navigate('/dashboard/brands')} />

            <Flex
                gap="8px"
                overflowX="auto"
                pb="2px"
                css={{
                    scrollbarWidth: 'thin',
                    '&::-webkit-scrollbar': { height: '5px' },
                    '&::-webkit-scrollbar-thumb': { background: BORDER, borderRadius: '3px' },
                }}
                sx={{
                    WebkitOverflowScrolling: 'touch',
                    scrollSnapType: 'x mandatory',
                }}
            >
                {isLoading ? (
                    Array.from({ length: BRAND_CAROUSEL_COUNT }).map((_, i) => (
                        <BrandSkeleton key={i} />
                    ))
                ) : items.length === 0 ? (
                    <Flex
                        w="full"
                        justify="center"
                        align="center"
                        py="16px"
                        color={FAINT}
                        fontSize="11px"
                    >
                        No brands available right now
                    </Flex>
                ) : (
                    items.map((brand) => (
                        <Flex
                            key={brand.brand_id ?? brand.name}
                            direction="column"
                            align="center"
                            gap="6px"
                            flexShrink={0}
                            minW="80px"
                            cursor="pointer"
                            onClick={() => goToBrand(brand)}
                            p="6px"
                            borderRadius="8px"
                            transition="background 0.15s ease"
                            _hover={{ bg: SURFACE_ALT }}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    goToBrand(brand);
                                }
                            }}
                            aria-label={`Shop ${brand.name}`}
                            sx={{ scrollSnapAlign: 'start' }}
                        >
                            <BrandAvatar brand={brand} size="52px" fontSize="18px" />
                            <Text
                                fontSize="10.5px"
                                fontWeight="600"
                                color={INK}
                                noOfLines={1}
                                maxW="76px"
                                textAlign="center"
                            >
                                {brand.name}
                            </Text>
                        </Flex>
                    ))
                )}
            </Flex>
        </Box>
    );
};

export default Brands;